<template>
  <div v-if="customLogo" class="logo-content enterprise-logo-content" @click="$emit('clickLogo')">
    <img
      class="enterprise-logo-icon"
      :src="imgIcon"
      alt
    />
  </div>
  <div v-else class="logo-content" @click="$emit('clickLogo')">
    <img
      class="logo-icon"
      :src="imgIcon"
      alt
    />
   <div class="dividLine"></div>
   <div class="logo-text">{{ $t("talentPlatform") }}</div>
  </div>
</template>

<script>
export default {
  name: "logo",
  components: {},
  props: {
    imgIcon: {
      type: String,
      default: ''
    },
    customLogo: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {}
  },
  watch: {},
  created() {
  },
  mounted() {
  },
  methods: {},
}
</script>

<style scoped lang="scss">
.logo-content {
  display: flex;
  flex-direction: row;
  align-items: center;

  .logo-icon {
   width: 62px; /*no*/
   height: var(--height-20);
  }

  .enterprise-logo-icon {
    width: auto;
    height: auto;
    max-height: 50px; /*no*/
    display: block;
  }

  // .logo-icon{
  //   width: var(--width-264);
  //   height: var(--height-24);
  // }

  .dividLine {
    margin: 0 var(--margin-x-10);
    background: var(--color-gray-line-deep);
    width: var(--width-1);
    height: var(--height-20);
  }

  .logo-text {
    font-size: 18px; /*no*/
    font-weight: var(--font-weight-l);
    color: #445765;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/home/logo.vue